var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info_stand"},[_c('imgs',{attrs:{"data":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }